export class RegisterUserModel {
    public emailAddress: string;
    public firstName: string;
    public lastName: string;
    public mobileNumber: string;
    public password: string;
    public passwordConfirmation: string;
    public mobileVerificationCode: string;
}
